var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 28 2.408-7.224A13.686 13.686 0 0 1 .483 13.76C.483 6.16 6.643 0 14.24 0 21.84 0 28 6.16 28 13.759c0 7.598-6.16 13.758-13.759 13.758-2.312 0-4.489-.573-6.401-1.58L0 28z",
    fill: "#2CB742"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.02 18.338c-.636-1.2-2.979-2.574-2.979-2.574-.53-.302-1.17-.336-1.472.203 0 0-.761.913-.955 1.044-.884.6-1.703.576-2.53-.25l-1.922-1.922-1.922-1.922c-.827-.827-.85-1.647-.251-2.531.131-.194 1.044-.955 1.044-.955.539-.303.505-.942.203-1.472 0 0-1.373-2.343-2.574-2.978a1.316 1.316 0 0 0-1.546.233l-.849.848c-2.692 2.693-1.366 5.732 1.326 8.424l2.46 2.461 2.461 2.46c2.692 2.693 5.732 4.019 8.424 1.326l.849-.848c.408-.41.503-1.037.232-1.547z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.d54be6c5c73272663d3b045fbaa52b13.svg";
export { ForwardRef as ReactComponent };